// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Fi-z","srOnly":"Gi-z"};